import React, {Component} from 'react';
import Image from '../../Containers/Image';
import Vis from './Vis';
import Icons from '../../Containers/Icons';
import Lightbox from 'lightbox-react';

class Cards extends Component {
  constructor(props){
    super(props);
    this.state = {
      image: "",
      note: "",
      priority: null,
      lightbox: false,
      image: ""
    }
  }
  changeText = (event) => {
    this.setState({note: event.target.value});
  }
  changeP = (priority) => {
    this.setState({priority: priority});
  }
  openImg = (img) => {
    this.setState({lightbox: true, image: img})
  }
  changeImg = (url) => {

  }
  changeCard = () => {
    let note;
    let priority;
    if (this.state.note) {
      note = this.state.note;
    } else {
      note = this.props.card.note;
    }
    if (this.state.priority) {
      priority = this.state.priority;
    } else {
      priority = this.props.card.priority;
    }
    let bodyCall = {
      type: "update",
      screen: "cards",
      post: {
        note: note,
        priority: priority,
        cardID: this.props.card.id,
        uID: this.props.uID,
        tabID: JSON.parse(this.props.tab.edit)
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res === true) {
        this.props.reload();
        this.props.msg("ok", "e05");
      } else {
        this.props.msg("error", "e04");
      }
    }).catch(error => {
      this.props.msg("error", "e04");
    });
  }


  render(){
    let {url, vis, card} = this.props;
    if (card !== null) {
      let priority = card.priority;
      return (
        <div className="Card">
          <div className="CardTitle">
            <Vis 
              changeText={this.changeText}
              priority={priority}
              abr={vis.abr}
              changeP={this.changeP}
            />
            <span className="arrow gray"><Icons name="arrowThin" /></span>
            <div className="CardName">
              {vis.name}
            </div>
            <span className="savebutton" onClick={() => this.changeCard()}><Icons name="save" /></span>
          </div>
          <Image url={url} img={card.image} openImg={this.openImg}/>
          {this.state.lightbox &&(
            <Lightbox
              mainSrc={this.state.image}
              onCloseRequest={() => this.setState({lightbox: false})}
              />
          )}
          <span>Nota</span>
          <textarea key={card.note} defaultValue={card.note} onChange={this.changeText}></textarea>
        </div>
      )
    } else {
      return (
        <div className="Card off">
          <div className="CardTitle off">
            <Vis 
              changeText={this.changeText}
              priority={this.changePriority}
              abr={vis.abr}
            />
            <span className="arrow gray"><Icons name="arrowThin" /></span>
            <div>
              {vis.name}
            </div>
          </div>
        </div>
      )
    }
  }
}

export default Cards;


// WEBPACK FOOTER //
// ./src/Components/Boards/Cards.js